"use client";

import Link from "next/link";
import DetourLogo from "@/assets/icons/detour-logo.svg";

function NoConfigurationUrl() {
  return (
    <div
      className={`
        flex min-h-screen w-full flex-col items-center justify-start gap-10 bg-background p-4 px-6
        py-8
        md:flex-1 md:p-8
      `}
    >
      <header
        className={`
          flex w-full justify-center
          md:justify-start
        `}
      >
        <nav className="flex justify-between">
          <Link href="/">
            <DetourLogo className="h-6 w-28 text-white" aria-label="Detour" />
          </Link>
        </nav>
      </header>
      <div
        className={`
          flex flex-col items-center justify-center gap-1
          md:flex-1
        `}
      >
        <h1 className="text-2xl font-bold text-foreground">
          No configuration for this URL
        </h1>
        <p className="text-center text-sm text-text-secondary">
          This link isn&apos;t set up yet. Please contact the link owner or try
          again later.
        </p>
      </div>
    </div>
  );
}

export default NoConfigurationUrl;
